export const MOCK_MODE_STORAGE_KEY = 'ws:mock:enabled';

const isWindowDefined = () => typeof window !== 'undefined';

const getMockModeFromStorage = (): boolean => {
  if (!isWindowDefined()) return false;
  const raw = window.localStorage.getItem(MOCK_MODE_STORAGE_KEY);
  return raw === '1' || raw === 'true';
};

export const isMockModeEnabled = (): boolean => {
  return getMockModeFromStorage();
};

export const setMockModeEnabled = (enabled: boolean): void => {
  if (!isWindowDefined()) return;
  window.localStorage.setItem(MOCK_MODE_STORAGE_KEY, enabled ? '1' : '0');
};
